import { CommonValidationMethods } from './common_validation_methods';
import { IValidationError } from './validations';
import { ValidationTypeArgs, CommonTypeBasedArgs } from './validation_types';

export interface OneToManyTypeArgs extends CommonTypeBasedArgs {
  type: 'ONE_TO_MANY';
  whiteListValueSet?: Set<any>;
}

export class OneToManyValidation extends CommonValidationMethods {
  static type = 'ONE_TO_MANY';

  static isOneToMany(validationTargetDataArgs: ValidationTypeArgs): validationTargetDataArgs is OneToManyTypeArgs {
    return validationTargetDataArgs.type === OneToManyValidation.type;
  }

  static validate(sourceData: any, sourceKey: string, targetDataConfig: OneToManyTypeArgs) {
    if (OneToManyValidation.isWhiteListedValue(sourceData, sourceKey, targetDataConfig)) {
      return true;
    }
    return OneToManyValidation.getFilteredData(sourceData, sourceKey, targetDataConfig).length >= 1;
  }

  static getErrorDetail(sourceData: any, sourceKey: string, targetDataConfig: OneToManyTypeArgs): IValidationError {
    const conditionChecked = OneToManyValidation.getConditionChecked(sourceData, sourceKey, targetDataConfig);

    const errorMessage = `One to many relationship check failed for ${JSON.stringify(sourceData)} in ${JSON.stringify(
      targetDataConfig['data']
    )}. Condition checked was ${JSON.stringify(conditionChecked)}`;

    return {
      errorMessage,
      type: OneToManyValidation.type,
      ...super.getErrorDetail(sourceData, sourceKey, targetDataConfig)
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/pi-validation/src/validation/one_to_many_validation.ts